# "Lazy loading" des images
# Utilise Unveil.js
# @link http://luis-almeida.github.io/unveil/
jQuery(document).on 'app.ready', ->

  $ 'img[data-src]'
    .unveil()
